export default "__VITE_ASSET__BrfFlhqg__"